export default __webpack_public_path__ + "static/media/applications-image-07.48dc6a0c.jpg";